import React from 'react';
import { FloridaRequirements } from '../components/florida/FloridaRequirements';
import { FLORIDA, NORTH_CAROLINA, PENNSYLVANIA } from '../constants';
import { GenericChoice, Qualification } from '../types';
import { NorthCarolinaRequirements } from '../components/northcarolina/NorthCarolinaRequirements';
import { PennsylvaniaRequirements } from '../components/pennsylvania/PennsylvaniaRequirements';

export function StateSpecificRequirements({
    state,
    update,
}: {
    state: string;
    update: (
        value: number | number[],
        choices: GenericChoice[],
        qualification: Qualification | null,
        category: 'education' | 'experience' | 'multiple' | 'single' | 'boolean',
    ) => void;
}) {
    const stateSpecificRequirements = {
        [FLORIDA]: FloridaRequirements,
        [NORTH_CAROLINA]: NorthCarolinaRequirements,
        [PENNSYLVANIA]: PennsylvaniaRequirements,
    };
    const StateSpecificRequirement =
        state in stateSpecificRequirements
            ? stateSpecificRequirements[state as keyof typeof stateSpecificRequirements]
            : null;

    return StateSpecificRequirement ? <StateSpecificRequirement update={update} /> : null;
}
